import axios from './axiosInstance'

const GetOrder = ({ token, _id }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios
      .post(`/orders/${_id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response))
  })
}

const GetOrdersOfUser = ({ token, _id, data }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post(`/orders/user/${_id}`, data)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response))
  })
}

const GetActiveOrdersOfVenue = ({ token, venues }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post('/orders/venue/activeOrders', { venues })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response))
  })
}

const GetPastOrdersOfVenue = ({ token, data }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post('/orders/venue/pastOrders', data)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response))
  })
}

const GetPastUsersOrdersOfVenue = ({ token, data }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post('/orders/GetPastUsersOrdersOfVenue', data)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response))
  })
}

const GetDeliveredOrdersOfVenue = ({ token, ids, range }) => {
  return new Promise((resolve, reject) => {
    console.log(ids)
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post('/orders/venue/deliveredOrders', { ids, range })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response))
  })
}

const GetAllOrders = ({ token, range }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post('/orders/venue/all', range)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response))
  })
}

const PlaceOrder = ({ order }) => {
  return new Promise((resolve, reject) => {
    axios.post('/orders/add', { order })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response))
  })
}

const ApproveOrder = ({ token, _id }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post(`/orders/approve/${_id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response))
  })
}

const RejectOrder = ({ token, _id, text }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post(`/orders/reject/${_id}`, { text })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response))
  })
}

const CancelOrder = ({ token, _id, reason }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post(`/orders/cancel/${_id}`, { reason })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response))
  })
}
const UnCancelOrder = ({ token, _id }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post(`/orders/uncancel/${_id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response))
  })
}
const DispatchOrder = ({ token, _id }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post(`/orders/dispatch/${_id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response))
  })
}

const UnDispatchOrder = ({ token, _id }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post(`/orders/undispatch/${_id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response))
  })
}
const DeliverOrder = ({ token, _id, paymentType }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post(`/orders/deliver/${_id}`, { paymentType })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response))
  })
}

const UnDeliverOrder = ({ token, _id }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post(`/orders/undeliver/${_id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response))
  })
}

const UsePoint = ({ token, _id, order }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post(`/orders/usepoint/${_id}`, order)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response))
  })
}

const UnUsePoint = ({ token, _id }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post(`/orders/unusepoint/${_id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response))
  })
}

const UpdateOrder = ({ token, order }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post(`/orders/update/${order._id}`, order)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response))
  })
}

const AddOrderComment = ({ token, orderId, user, text }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post(`/orders/addComment/${orderId}`, { user, text })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response))
  })
}
const DeleteOrderComment = ({ token, orderId, commentId }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post(`/orders/deleteComment/${orderId}`, { commentId })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response))
  })
}

const CalculateOrder = ({
  venue,
  cartItems,
  paymentType,
  user,
  isInShopOrder,
  isTakeAwayOrder
}) => {
  return new Promise((resolve, reject) => {
    axios.post('/orders/calculate', {
      venue,
      cartItems,
      paymentType,
      user,
      isInShopOrder,
      isTakeAwayOrder
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response))
  })
}

const OrderCheck = ({ token, venue, user }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios
      .post('/orders/orderCheck', { venue, user })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response))
  })
}

const SearchOrder = ({ token, term }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios
      .get(`/orders/search/${term}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response))
  })
}

const GetOrderAddressesOfUser = ({ token, _id }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios
      .get(`/orders/user/${_id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response))
  })
}

export {
  GetOrder,
  GetOrdersOfUser,
  GetOrderAddressesOfUser,
  GetActiveOrdersOfVenue,
  GetPastOrdersOfVenue,
  GetDeliveredOrdersOfVenue,
  GetAllOrders,
  GetPastUsersOrdersOfVenue,
  PlaceOrder,
  UpdateOrder,
  ApproveOrder,
  RejectOrder,
  CancelOrder,
  UnCancelOrder,
  DispatchOrder,
  UnDispatchOrder,
  DeliverOrder,
  UnDeliverOrder,
  UsePoint,
  UnUsePoint,
  CalculateOrder,
  OrderCheck,
  SearchOrder,
  AddOrderComment,
  DeleteOrderComment
}
